<template>
  <div v-if="!isMeiju" class="navigationBar">
    <div v-if="name!='美书' || from === 'control'" class="return" @click="goblack"><i class="icon iconfont icon-fanhui"></i> </div>
    <span  class="title2">{{ parentToChild }}</span>
  </div>
</template>

<script>
    import getGoodsId from '@/components/common/getGoodsId'
    export default {
        name: '',
        data () {
            return {
              name:'',
              name2:'',
              show: true,
              from: '',
              isMeiju: false
//              oftenGoods:[],
//              oftenGoods:{msCategory:{}}
            }
        },
        props:{
          parentToChild: {
            type: String,
            default: ''
          }
        },
        methods:{
          goblack(){
            this.$router.go(-1);
          }
      },created(){
        this.from = getGoodsId('from');
        if(this.$route.name === "Allproduct"){
          this.name='美书';
        }
        else if(this.$route.name === "Collection"){
          this.name='美书';
        }
        else {
          this.name=this.$route.name;
        }
        // 是否是美居
         const ua = navigator.userAgent.toLowerCase(); 
         this.isMeiju = /meiju|msmart/.test(ua);

      },mouted(){
        
      }
    }
</script>


<style>
  .return{
    position: absolute;left:30px;
    font-size:50px;
    font-weight: 600;
    top:-3px;
  }
  .title2{
    width: 70%;
    display: inline-block;
    text-align: center;
    white-space:nowrap;
    overflow: hidden;
  }
  .navigationBar{
    height: 100px;
    width: 100%;
    text-align: center;
    background-color: white;
    color: #1f2230;
    line-height:100px;
    font-size: 30px;
    position:fixed;
    top:0;
    z-index: 999;
  }
  .collection .no-collection{
    margin: 0 auto;
    margin-top: 60px;
    height: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/components/navigationbar.vue